import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal } from "antd";
import React from "react"
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { editNocProvider } from "../../../../store/NocProviderSlice";
import FormNocProvider from "./FormNocProvider";

const EditNocProvider: React.FC<any> = ({
    openEditModal,
    handleEditModal,
    getList,
    editModalData
}) => {
    const dispatch: AppDispatch = useDispatch();
    const [form] = Form.useForm();
    const handleEditSubmit = (data: any) => {
        dispatch(editNocProvider(data))
            .then(() => {
                handleEditModal();
                getList();
            })
            .catch(() => { });
    };
    return (
        <Modal
            open={openEditModal}
            destroyOnClose
            width={800}
            onCancel={handleEditModal}
            closeIcon={<FontAwesomeIcon icon={faTimes} />}
            footer={false}
            className="addModal"
            title={`Update Provider`}
        >
            <FormNocProvider
                form={form}
                mode={'edit'}
                editModalData={editModalData}
                handleEditSubmit={handleEditSubmit}
                handleEditModal={handleEditModal}
            />
        </Modal>
    );
}
export default EditNocProvider